import React, { useEffect, useRef, useState } from "react";
import { Formik, Field, ErrorMessage, Form } from "formik";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import FieldInput from "../../../CustomComponents/FieldInput";
import ReactSelect from "react-select";
import { useDispatch, useSelector } from "react-redux";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import * as yup from "yup";
import { ModalBody } from "react-bootstrap";
import { updateProfile } from "../../../../redux/profile/action";
import NumberInputBox from "../../../CustomComponents/AllCustomeInput/NumberInputBox";

const formdatatomap = [
  {
    title: "Are you open for part time job?",
    name: "part_time",
    placeholder: "part_time",
  },
  {
    title: "Price per hour in $",
    name: "price_per_hour",
    placeholder: "Enter Price per hour",
  },
  {
    title: "Price per month in $",
    name: "price_per_month",
    placeholder: "Enter Price per month",
  },
  {
    title: "Preferred working country",
    name: "working_country",
    placeholder: "working_country",
  },
  {
    title: "Preferred work location",
    name: "work_location",
    placeholder: "work_location",
  },
];

export default function ProfileModelCompanyPrice({
  edittype,
  formData,
  setFormData,
  setModelCompanyPrice,
}) {
  const [category, setCategory] = useState("");
  const [country, setCountry] = useState("");
  const [selectCountry, setSelectCountry] = useState(
    formData?.working_country_index,
  );
  const formikRef = useRef(null);

  const initialValues = {
    work_location:
      formData?.company?.work_location || formData?.work_location || 1,
    part_time: formData?.company?.part_time || formData?.part_time || 1,
    price_per_hour:
      formData?.company?.price_per_hour || formData?.price_per_hour,
    price_per_month:
      formData?.company?.price_per_month || formData?.price_per_month,
    working_country:
      formData?.company?.working_country || formData?.working_country,
  };

  const cvpreferences1 = yup.object().shape({
    part_time: yup.string().required("Part time job preference is required"),
    price_per_hour: yup
      .number()
      .typeError("Price per hour must be a number")
      .required("Price per hour is required"),
    price_per_month: yup
      .number()
      .typeError("Price per month must be a number")
      .required("Price per month is required"),
    working_country: yup
      .string()
      .required("Preferred working country is required"),
    work_location: yup.string().required("Preferred work location is required"),
  });

  const path = "Assets/scss/FirstTimeUsers.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);
  const dispatch = useDispatch();

  const countrylist = useSelector(({ master: { countrylist } }) => countrylist);

  useEffect(() => {
    setCountry(countrylist);
  }, [countrylist]);

  const catindex = Array.isArray(countrylist) && countrylist?.find(
    (item) => item.id == initialValues.working_country,
  );
  let country_index;

  useEffect(() => {
    if (initialValues?.working_country) {
      country_index = { value: catindex?.id, label: catindex?.title };
      setSelectCountry(country_index);
    }
  }, [initialValues, initialValues?.working_country]);

  const handleSubmit = async (values) => {
    const data = {
      ...values,
      type: "company_price",
    };
    if (edittype == 1) {
      dispatch(updateProfile(data));
      setModelCompanyPrice(false);
    } else {
      setFormData((prevData) => ({
        ...prevData,
        ...values,
      }));
      setModelCompanyPrice(false);
    }
  };

  const handleWorkingcountryChange = (selectedOption, formik) => {
    setSelectCountry(selectedOption);
    formik.setValues({
      ...formik.values,
      working_country_index: selectedOption,
      working_country: selectedOption.value,
    });
  };
  const handleNextClick = () => {
    if (formikRef.current) {
      formikRef.current.submitForm();
    }
  };
  return (
    <>
      <button
        onClick={() => setModelCompanyPrice((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt=""
        />
      </button>
      <ModalBody>
        <h4>Edit Charges</h4>
        <div>
          <Formik
            initialValues={initialValues}
            onSubmit={handleSubmit}
            validationSchema={formData?.part_time == 1 ? cvpreferences1 : ""}
            innerRef={formikRef}
            enableReinitialize
          >
            {(formik) => (
              <Form>
                <div>
                  {formdatatomap.map((prop, key) => {
                    if (prop.name == "working_country") {
                      if (
                        prop.name == "working_country" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <>
                            <div className="form-group">
                              <label>Preferred working country</label>
                              <ReactSelect
                                options={
                                  Array.isArray(country) &&
                                  country.map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                }
                                placeholder="Select country"
                                // value={selectCountry}
                                 value={
                                Array.isArray(country) &&
                                country
                                  .map((lang) => ({
                                    value: lang.id,
                                    label: lang.title,
                                  }))
                                  .find(
                                    (option) =>
                                      option.value ===
                                      formik.values.working_country
                                  )
                              }
                                onChange={(options) => {
                                  handleWorkingcountryChange(options, formik);
                                }}
                              />
                              <ErrorMessage
                                name={prop.name}
                                component="div"
                                className="error"
                              />
                            </div>
                          </>
                        );
                      }
                      return null;
                    }

                    if (prop.name == "full_time_job") {
                      if (
                        prop.name == "full_time_job" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 1
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="1"
                                />
                                <span className="checkmark">Yes</span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 2
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="2"
                                />
                                <span className="checkmark">No</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "work_location") {
                      if (
                        prop.name == "work_location" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <div key={key} className="form-group">
                            <h6 className="work-title">{prop.title}</h6>
                            <div className="checkbox-label">
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 1
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="1"
                                />
                                <span className="checkmark">Virtual </span>
                              </label>
                              <label className="checkbox-container">
                                <Field
                                  type="radio"
                                  checked={
                                    formik.values[prop.name] == 2
                                      ? "checked"
                                      : ""
                                  }
                                  name={prop.name}
                                  value="2"
                                />
                                <span className="checkmark">Physical</span>
                              </label>
                            </div>
                            <ErrorMessage
                              name={prop.name}
                              component="div"
                              className="error"
                            />
                          </div>
                        );
                      }
                      return null;
                    }
                    if (prop.name == "part_time") {
                      return (
                        <div key={key} className="form-group">
                          <h6 className="">{prop.title}</h6>
                          <div className="checkbox-label">
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                checked={
                                  formik.values[prop.name] == 1 ? "checked" : ""
                                }
                                name={prop.name}
                                value="1"
                              />
                              <span className="checkmark">Yes</span>
                            </label>
                            <label className="checkbox-container">
                              <Field
                                type="radio"
                                checked={
                                  formik.values[prop.name] == 2 ? "checked" : ""
                                }
                                name={prop.name}
                                value="2"
                              />
                              <span className="checkmark">No</span>
                            </label>
                          </div>
                          <ErrorMessage
                            name={prop.name}
                            component="div"
                            className="error"
                          />
                        </div>
                      );
                    }
                    if (prop.name == "price_per_hour") {
                      if (
                        prop.name == "price_per_hour" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }
                    if (prop.name == "price_per_month") {
                      if (
                        prop.name == "price_per_month" &&
                        formik.values?.part_time == 1
                      ) {
                        return (
                          <NumberInputBox
                            title={prop.title}
                            name={prop.name}
                            placeholder={prop.placeholder}
                            key={key}
                          />
                        );
                      }
                      return null;
                    }

                    return (
                      <FieldInput
                        title={prop.title}
                        name={prop.name}
                        placeholder={prop.placeholder}
                        key={key}
                      />
                    );
                  })}
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </ModalBody>
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleNextClick}>
          Save
        </button>
      </div>
    </>
  );
}
